import { BorderedRadioButton, Checkbox, DateInput, RadioGroup, TextInput } from 'slab'

import { COBRA_EMPLOYEE_THRESHOLD } from './constants'

interface OffboardingFormFieldsProps {
  employeeId: string
  finalDayOfEmployment: string | null
  cobraEligible: boolean | null
  personalEmail: string
  onFieldChange: (field: string, value: string | boolean | null) => void
  minDate: string
  maxDate: string
  dateInputClassName?: string
  showCobraConfirmation: boolean
  cobraConfirmationChecked: boolean
  onCobraConfirmationChange: (checked: boolean) => void
  displayEmployerName: string
  currentYear: number
}

export function OffboardingFormFields ({
  employeeId,
  finalDayOfEmployment,
  cobraEligible,
  personalEmail,
  onFieldChange,
  minDate,
  maxDate,
  dateInputClassName = 'w-full',
  showCobraConfirmation,
  cobraConfirmationChecked,
  onCobraConfirmationChange,
  displayEmployerName,
  currentYear,
}: OffboardingFormFieldsProps) {
  return (
    <>
      <div className={dateInputClassName}>
        <DateInput
          label='Final day of full-time employment'
          value={finalDayOfEmployment ?? ''}
          onChange={(e) => onFieldChange('finalDayOfEmployment', e.target.value || null)}
          min={minDate}
          max={maxDate}
        />
      </div>

      <RadioGroup
        name={`cobra-eligible-${employeeId}`}
        label='Is this employee eligible for COBRA?'
        layout='horizontal'
        gap={4}
      >
        <BorderedRadioButton
          value='yes'
          label='Yes'
          size='small'
          checked={cobraEligible === true}
          onChange={() => onFieldChange('cobraEligible', true)}
        />
        <BorderedRadioButton
          value='no'
          label='No'
          size='small'
          checked={cobraEligible === false}
          onChange={() => onFieldChange('cobraEligible', false)}
        />
      </RadioGroup>

      <TextInput
        label='Personal email'
        type='email'
        value={personalEmail}
        onChange={(e) => onFieldChange('personalEmail', e.target.value)}
      />

      {showCobraConfirmation && (
        <Checkbox
          checked={cobraConfirmationChecked}
          onChange={(e) => onCobraConfirmationChange(e.target.checked)}
          label={`I confirm that ${displayEmployerName} had at least ${COBRA_EMPLOYEE_THRESHOLD} employees on most typical days of ${currentYear}.`}
        />
      )}
    </>
  )
}
